import { render } from "./LinkIcon.vue?vue&type=template&id=38e0772e&scoped=true"
const script = {}

import "./LinkIcon.vue?vue&type=style&index=0&id=38e0772e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e0772e"]])

export default __exports__